import shajs from 'sha.js';
import * as browser from '../../../util/cookie';

export const COOKIE_NAME = 'CLIENT_MARKER';

const sha256 = shajs('sha256');

export function generateMarker() {
	const salt = Math.random() + '' + Math.random() + '' + Math.random() + '' + Math.random();
	const timestamp = Date.now();
	const key = sha256.update(salt + timestamp).digest('hex');

	return key;
}

export function getMarker() {
	const marker = browser.getCookie(COOKIE_NAME);

	if (marker && marker !== 'undefined') {
		return marker;
	}
	const generated = generateMarker();

	browser.setCookie(COOKIE_NAME, generated, {path: '/'});
	return generated;
}



// WEBPACK FOOTER //
// ./src/client/services/analytics/marker.js